export const toPercentage = (num: number) => `${num.toFixed(0)}%`;
